import React from "react";
import videoImage from "../../asset/video image.png";
import { IoCheckmarkCircle } from "react-icons/io5";
import { useInView } from "react-intersection-observer";

const AboutDirector = () => {
  const { ref: refOne, inView: inViewOne } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: refTwo, inView: inViewTwo } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  return (
    <div className="xl:py-20 lg:py-16 py-12">
      <div className="flex justify-between md:flex-row flex-col items-center xl:gap-8 lg:gap-6 md:gap-4 gap-8 xl:px-[5%] lg:px-[3%] md:px-[2%] px-[6%]">
        <div
          ref={refOne}
          className={`flex-1 flex flex-col items-start lg:gap-4 md:gap-2 gap-4 xl:text-[1.2rem] lg:text-[1rem] md:text-[.9rem] text-[1rem] ${
            inViewOne ? "animate-slideRight" : "opacity-0"
          }`}
        >
          <div className="xl:text-[2.5rem] lg:text-[1.8rem] md:text-[1.5rem] text-[2rem] font-bold">
            RDA Director General{" "}
            <span className="text-[#00643b]">Kinza Murtaza</span>
          </div>
          <span className=" text-[#2B2B2B]">
           Under the able leadership of Honorable Chief Minister Maryam Nawaz Sharif, visionary guidance of Chief Secretary Zahid Akhtar Zaman, and able supervision of Honorable Secretary Housing, Urban Development and Public Health Engineering Department, Noor-ul-Amin Mengal, the current Director General, Kinza Murtaza, strives to serve the people of Rawalpindi, in order to improve urban living and public facilitation.
          </span>
          {/* <ul className="flex flex-col lg:gap-3 md:gap-1.5 gap-2.5 text-[#2B2B2B] image-list">
            <li className="flex items-start gap-4">
              <IoCheckmarkCircle className="  md:size-12 sm:size-9 size-10  xl:mt-[-8px] sm:mt-[-6px] mt-[-7px] md:mt-[-12px] text-[#00643b]" />
              <img src={listIcon} className=" rounded-full w-4 mt-1.5" alt="" /> */}
              {/* Crackdown on Illegal Housing Schemes: Under her leadership, RDA
              has issued notices to 149 illegal housing schemes to protect the
              public from fraudulent activities.
            </li>
            <li className="flex items-start gap-4">
              <IoCheckmarkCircle className="  md:size-12 sm:size-9 size-10  xl:mt-[-8px] sm:mt-[-6px] mt-[-7px] md:mt-[-12px] text-[#00643b]" />
              <img src={listIcon} className=" rounded-full w-4 mt-1.5" alt="" />{" "} */}
              {/* Closure of Illegal Commercial Properties: The RDA sealed 11
              commercial properties on Caltex Road in the Morgah area due to
              unauthorized constructions. 
            </li>
          </ul> */}
        </div>
        <div
          ref={refTwo}
          className={`flex-1 flex justify-end ${
            inViewTwo ? "animate-slideLeft" : "opacity-0"
          }`}
        >
          <img src={videoImage} className=" rounded-2xl" alt="" />
        </div>
      </div>
    </div>
  );
};

export default AboutDirector;
